import { LagoonSDK } from './LagoonSDK';
import { getLagoonEnv } from './helpers';

const lagoonEnv = getLagoonEnv();

export const lagoon = new LagoonSDK(
  'link-enhanced-provider-validation',
  lagoonEnv,
  {
    loadTables: true,
    loadForms: false,
  }
);
